import type { ShopperProducts } from '@/scapi';
import type { ContentFolder } from '@/lib/api/content-folders.server';
import { getMenuExternalUrl } from '@/lib/menu-link';

type Category = ShopperProducts.schemas['Category'];

export function isContentFolderVisibleInMenu(folder: ContentFolder): boolean {
    return folder.showInMenu === true;
}

/** Recursively keeps only folders flagged with `showInMenu`. */
export function filterContentFoldersForMenu(folders: ContentFolder[]): ContentFolder[] {
    return folders.filter(isContentFolderVisibleInMenu).map((folder) => ({
        ...folder,
        folders: folder.folders ? filterContentFoldersForMenu(folder.folders) : undefined,
    }));
}

export function findContentFolderById(folders: ContentFolder[], id: string): ContentFolder | undefined {
    for (const folder of folders) {
        if (folder.id === id) return folder;
        if (folder.folders?.length) {
            const result = findContentFolderById(folder.folders, id);
            if (result) return result;
        }
    }
    return undefined;
}

function mapFolderToCategory(folder: ContentFolder): Category {
    const externalUrl = getMenuExternalUrl(folder.externalUrl);

    return {
        id: folder.id,
        name: folder.name,
        c_url: folder.path,
        ...(externalUrl ? { c_externalUrl: externalUrl } : {}),
        ...(folder.customerGroupId?.length ? { c_customerGroupId: folder.customerGroupId } : {}),
        categories: folder.folders?.map(mapFolderToCategory),
    };
}

/**
 * Maps editorial content folders to the SCAPI Category shape used by navigation menus (L1 → L2 → L3).
 */
export function mapContentFoldersToCategories(contentFolders: ContentFolder[]): Category[] {
    return contentFolders.map(mapFolderToCategory);
}
